"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLink = exports.ensureItemIsVisible = exports.sanitizeIds = exports.isCategory = exports.getId = void 0;

var _castArray = _interopRequireDefault(require("lodash/castArray"));

var _get = _interopRequireDefault(require("lodash/get"));

var _focusWithoutScrolling = _interopRequireDefault(require("../../utils/focusWithoutScrolling"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getId = function getId(item) {
  return item.id || item.label;
};

exports.getId = getId;

var isCategory = function isCategory(item) {
  return 'items' in item && Array.isArray(item.items);
};

exports.isCategory = isCategory;

var sanitizeIds = function sanitizeIds() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var multiple = arguments.length > 1 ? arguments[1] : undefined;
  var validIds = (0, _castArray.default)(ids || []).filter(Boolean);

  if (multiple) {
    return validIds;
  }

  return validIds.length ? [validIds[0]] : [];
};

exports.sanitizeIds = sanitizeIds;

var ensureItemIsVisible = function ensureItemIsVisible(container, itemId, options) {
  if (!container) {
    return;
  }

  var activeEl = container && container.querySelector("[data-id=\"".concat(itemId, "\"]"));

  if (!container || !activeEl) {
    return;
  }

  if ((0, _get.default)(options, 'focus')) {
    (0, _focusWithoutScrolling.default)(activeEl);
  }

  if (container.scrollHeight > container.clientHeight) {
    var containerScrollBottom = container.clientHeight + container.scrollTop;
    var elBottom = activeEl.offsetTop + activeEl.offsetHeight;

    if (elBottom > containerScrollBottom) {
      // eslint-disable-next-line no-param-reassign
      container.scrollTop = elBottom - container.clientHeight;
    } else if (activeEl.offsetTop < container.scrollTop) {
      // eslint-disable-next-line no-param-reassign
      container.scrollTop = activeEl.offsetTop;
    }
  }
};

exports.ensureItemIsVisible = ensureItemIsVisible;

var isLink = function isLink(item) {
  return 'linkTo' in item && !!item.linkTo;
};

exports.isLink = isLink;